import { render, staticRenderFns } from "./SaleDetailQuery.vue?vue&type=template&id=797fc326"
import script from "./SaleDetailQuery.vue?vue&type=script&lang=js"
export * from "./SaleDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports